import React, {Component} from 'react';
import template from './../../../templates/PageLayout/Popups/Calendar.rt';
import * as actions from '../../../actions';
import {connect} from 'react-redux';
import _ from 'lodash';
import * as calendarActions from './../../../actions/A_Calendar';
import Misc from './../../../misc';
import $ from 'jquery';
import {DefaultColors} from './../../../constants/defaultColors';
import {injectIntl} from "react-intl";

const StatusColorMap = {
  'contracted': DefaultColors.green,
  'contacted': DefaultColors.blue,
  'call back': DefaultColors.blue,
  'template': DefaultColors.green,
  'install': DefaultColors.green,
  'complete': DefaultColors.green,
  'appointment': DefaultColors.blue,
  'pending': DefaultColors.yellow,
  'cabinets': DefaultColors.yellow,
  'not interested': DefaultColors.red,
  'over budget': DefaultColors.red,
  'beat by competitor': DefaultColors.red,
  'bad contact info': DefaultColors.red,
  'no show': DefaultColors.red,
  'no answer': DefaultColors.yellow,
  'dead lead': DefaultColors.red
};

class Calendar extends Component {
  render = template;

  componentDidMount() {
    $('.schedule-overview-scroller').scrollTop(this.props.selectedDate.month() * 325);

    const {selectedDate} = this.props;
    this.props.selectDay(selectedDate.month(), selectedDate.date())
  }
}

function getEntryColor(entryStatus) {
  return entryStatus ? (StatusColorMap[entryStatus.toLowerCase()] || DefaultColors.blue) : DefaultColors.blue;
}

function prepareEntries(calendar) {
  let res = [];
  const {job} = calendar;
  for (let i = 5; i <= 22; i++) {
    res.push({
      hour: i,
      stringHour: Misc.toHourString(i),
      entries: []
    });
  }

  _.forEach(calendar.latestEntries, e => {
    const hour = e.roundedHour;
    const r = _.find(res, {hour: hour});
    if (r) {
      r.entries.push({
        hour: hour,
        customer: e.customer,
        color: getEntryColor(e.lastStatus),
        id: e.id,
        isSelected: e.jobId === job.id && e.jobIdType === job.jobIdType,
        entry: e
      });
    }
  });

  return res;
}

function mapStateToProps(state) {
  const {calendar} = state;
  return {
    visibleYear: calendar.visibleYear,
    selectedDate: calendar.selectedDate,
    dayEntries: prepareEntries(calendar)
  }
}

function mapDispatchToProps(dispatch) {
  return {
    selectDay: (month, day) => dispatch(calendarActions.fetchJobScheduleEntries(month, day)),
    selectYear: sign => dispatch(calendarActions.selectYear(sign)),
    close: () => dispatch(actions.jobBoardShowJobScheduling(null, false)),
    addScheduleEntry: (entry) => dispatch(calendarActions.showScheduleEntry(true, true)),
    editScheduleEntry: entry => dispatch(calendarActions.showScheduleEntry(true, false, entry))
  }
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(Calendar)
);



